module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 5
// module chunks = 0